import { useMemo } from 'react';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import AddPhone from './AddPhone';
// import DelayTime from './DelayTime';
import { addMessagePolicy, editMessagePolicy } from '../../actions/message-policy';
import { CardContainer, Heading5, Heading6, Icon, TitleIcon } from '../widgets';

const MessageForm = ({ onHide, type, values, crewList, implementOperatorOptions, truckOperatorOptions, userList, incidentTypes }) => {
    const isAdd = type === 'add';
    const { farmId } = useParams();
    const dispatch = useDispatch();

    const initialType = [
        { value: 1, label: 'Crew' },
        { value: 2, label: 'Farm Manager' },
        { value: 3, label: 'Implement Operator' },
        { value: 4, label: 'Truck Operator' }
    ];

    const configurationOption = useMemo(() => {
        if (!incidentTypes || incidentTypes.length === 0) return [];

        return incidentTypes.map(e => ({
            value: e.incident_type,
            label: e.incident_type_name,
            incidentId: e.incident_id,
            sms_delay_duration: 30
        }))
    }, [incidentTypes]);

    const [configType, setConfigType] = useState({});
    const [phoneList, setPhoneList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([{ label: '', value: '' }]);
    const [selectedConfigurations, setSelectedConfiguration] = useState(configurationOption.slice(0, 4));
    const [isValid, setValid] = useState({ phone: true, field: true, type: true });

    useEffect(() => {
        if (values && values.hasOwnProperty('policy_config')) {
            const policies = values.policy_config;
            const type = initialType.filter(e => e.label === values.policy_type);

            const configurations = policies.filter(e => e.enabled).map(e => ({
                value: e.incident_type,
                label: e.incident_type_name,
                incidentId: e.incident_id,
                sms_delay_duration: e.configuration.sms.delay_duration
            }));

            setSelectedIds(values.entity_name);
            setSelectedConfiguration(configurations);
            setConfigType(type && type.length > 0 ? type[0] : {});
        }
    }, [values]);

    const selectOption = useMemo(() => {
        if (isAdd) setSelectedIds([]);
        const value = configType && configType.value ? configType.value : null;

        switch (value) {
            case 1: return crewList;
            case 2: return userList;
            case 3: return implementOperatorOptions;
            case 4: return truckOperatorOptions;
            default: return crewList;
        }
    }, [configType]);

    // const handleDelayTime = (data, num) => {
    //     const delayTimeEditedData = selectedConfigurations.map(e => {
    //         if (e.value === data.value) {
    //             return { ...e, sms_delay_duration: num }
    //         }
    //         else return e;
    //     })

    //     setSelectedConfiguration(delayTimeEditedData);
    // }

    const handleAdd = () => {
        let policies = {}
        let phoneArr = [];

        phoneList.forEach(e => {
            if (e.phone && e.phone.toString().trim().length !== 0) phoneArr.push(`${e.code}-${e.phone}`);
        });

        if (configurationOption && configurationOption.length > 0) configurationOption.forEach(e => policies[e.value] = {
            incident_id: e.incidentId,
            enabled: false,
            sms_delay_duration: e.sms_delay_duration
        });
        if (selectedConfigurations && selectedConfigurations.length > 0) selectedConfigurations.forEach(e => policies[e.value] = {
            incident_id: e.incidentId,
            enabled: true,
            sms_delay_duration: e.sms_delay_duration
        });

        if (isAdd) {
            let entityArr = [];

            if (selectedIds && selectedIds.length > 0) {
                selectedIds.forEach(e => {
                    if (e.hasOwnProperty('value') && e.value.toString().trim().length > 0) {
                        entityArr.push({
                            entity_uuid: e.value,
                            entity_type_id: configType.value === 1 ? 8 : 5,
                        });
                    }
                });
            }

            const params = {
                farm_uuid: farmId,
                entities: entityArr,
                phones: phoneArr,
                policy_config: policies,
                policy_type: configType.hasOwnProperty('label') ? configType.label : 'Crew'
            };

            if (phoneArr.length === 0 || entityArr.length === 0 || !configType.hasOwnProperty('label')) {
                setValid({
                    ...isValid,
                    field: entityArr.length > 0,
                    phone: phoneArr.length > 0,
                    type: configType.hasOwnProperty('label'),
                });
            }
            else {
                dispatch(addMessagePolicy(params));
                onHide(false);
            }
        }
        else {
            if (phoneArr.length === 0 || !configType.hasOwnProperty('label'))
                setValid({
                    ...isValid,
                    phone: phoneArr.length > 0,
                    type: configType.hasOwnProperty('label')
                });

            const params = {
                farm_uuid: farmId,
                policy_id: values.policy_id,
                entity_uuid: values.entity_uuid,
                entity_type_id: values.entity_type_id,
                policy_type: values.hasOwnProperty('policy_type') ? values.policy_type : 'Crew',
                policy_config: policies,
                phones: phoneArr,
            };

            if (phoneArr.length === 0) setValid({ ...isValid, phone: false });
            else {
                dispatch(editMessagePolicy(params));
                onHide(false);
            }
        }
    };

    return (
        <CardContainer className='form-container'>
            <Card className='card-form'>
                <Card.Header>
                    <Card.Title>
                        <Heading5>
                            <TitleIcon className={isAdd ? 'fa fa-cogs' : 'fa fa-pencil'} />{isAdd ? 'Add Configuration' : 'Edit Configuration'}
                        </Heading5>
                        <i className='fa fa-times close-btn' aria-hidden='true' title='close'
                            onClick={() => onHide(false)} />
                    </Card.Title>
                </Card.Header>

                <Card.Body>
                    <Row>
                        {isAdd && <Col className='col-12' style={{ zIndex: 200 }}>
                            <Form.Group>
                                <Heading6>Type</Heading6>
                                <Select
                                    className='select'
                                    closeMenuOnSelect={true}
                                    onChange={e => setConfigType(e)}
                                    options={initialType}
                                />

                                {!isValid.type && <div className='mt-2' style={{ color: 'red' }}>This field is required</div>}
                            </Form.Group>
                        </Col>}

                        {configType.hasOwnProperty('value') &&
                            <Col className='col-12 mt-4' style={{ zIndex: 100 }}>
                                <Form.Group>
                                    <Heading6>{initialType[configType.value - 1].label}</Heading6>
                                    {isAdd ?
                                        <Select
                                            style={{ zIndex: '999' }}
                                            className='select'
                                            isMulti={configType.value === 1}
                                            placeholder={'Select'}
                                            closeMenuOnSelect={configType.value !== 1}
                                            value={selectedIds}
                                            onChange={e => {
                                                if (configType.value === 1) setSelectedIds(e);
                                                else setSelectedIds([e]);
                                            }}
                                            options={selectOption} />
                                        :
                                        <Form.Control
                                            id='Field'
                                            readOnly={true}
                                            placeholder='Select'
                                            name='Field'
                                            onChange={(e) => setSelectedIds(e && e.value ? e.value : null)}
                                            value={selectedIds}
                                            options={selectOption}
                                        />
                                    }

                                    {!isValid.field && <div className='mt-2' style={{ color: 'red' }}>This field is required</div>}
                                </Form.Group>
                            </Col>}
                    </Row>

                    {configType.hasOwnProperty('value') &&
                        <Row className='mt-4'>
                            <Col className='col-12' style={{ zIndex: 10 }}>
                                <Form.Group>
                                    <Heading6>Configuration</Heading6>
                                    <Select
                                        className='select'
                                        isMulti
                                        placeholder={'Select'}
                                        closeMenuOnSelect={false}
                                        value={selectedConfigurations}
                                        onChange={e => setSelectedConfiguration(e)}
                                        options={configurationOption} />
                                </Form.Group>
                            </Col>
                        </Row>}

                    {/* {configType.hasOwnProperty('value') &&
                        <Row className='mt-2'>
                            <Col className='col-12'>
                                <DelayTime
                                    configurations={selectedConfigurations}
                                    onChange={handleDelayTime}
                                />
                            </Col>
                        </Row>} */}

                    {configType.hasOwnProperty('value') && <Row className='mt-4'>
                        <Col className='col-12'>
                            <Heading6>Phone</Heading6>
                            <AddPhone data={values} onChange={(e) => setPhoneList(e)} isValid={isValid.phone} />
                        </Col>
                    </Row>}

                </Card.Body>
                <Card.Footer>
                    <Button
                        size='sm'
                        type='button'
                        variant='primary'
                        className='float-right ml-3'
                        onClick={() => handleAdd()}>
                        <Icon className='fa fa-floppy-o' /> Save
                    </Button>
                    <Button
                        size='sm'
                        type='button'
                        variant='danger'
                        className='float-right'
                        onClick={() => onHide(false)}>
                        <Icon className='fa fa-times-circle' /> Cancel
                    </Button>
                </Card.Footer>
            </Card>
        </CardContainer>
    );
};

export default MessageForm;